import React, { FC, useContext, useEffect, useState } from 'react';

import classNames from 'classnames';

import { Checkbox } from '@shared/ui';

import cls from './BodyComponents.module.css';
import { DateInput } from '../../../../../components/DateInput/DateInput';
import { FormBlock } from '../../../../../components/UI/Form/FormBlock/FormBlock';
import { Select } from '../../../../../components/UI/Select/Select';
import { Input } from '../../../../../components/UI/TextInput/Input';
import { ModalAddContext } from '../ModalAdd';

export const NotBindBlock = () => {
    const {
        currentList,
        isActiveCheckbox,
        onCheckboxChange,
        formState,
        formHandler,
        onCurrencyChange,
        selectedCurrency,
        onDateChange,
        errors,
        sumFormHandler,
    } = useContext(ModalAddContext);
    const { account_number, opening_balance_value, title } = formState;

    useEffect(() => {
        const initialState = {
            title: null,
            accountStartBalance: null,
            currency: null,
        };
        if (errors.notBind) {
            errors.notBind.forEach((error) => {
                initialState[error.name] = error.messages.toString();
            });
        }
        setErrorsTab(initialState);
    }, [errors.notBind]);

    const [errorsTab, setErrorsTab] = useState({
        title: null,
        accountStartBalance: null,
        currency: null,
    });

    return (
        <div className={classNames(cls.formBlock)}>
            <FormBlock>
                <Input
                    isRequired
                    title={i18next.t('NotBindBlock.return.InputTitle.title')}
                    name="title"
                    value={title}
                    onChange={formHandler}
                    error={errorsTab.title}
                />
            </FormBlock>
            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Input
                        isRequired={false}
                        title={i18next.t('NotBindBlock.return.InputAccount_number.title')}
                        name="account_number"
                        value={account_number}
                        onChange={formHandler}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <DateInput
                        title={i18next.t('NotBindBlock.return.DateInput.title')}
                        isRequired={false}
                        date={formState.opening_balance_date}
                        inventoryGuid="inventoryGuid"
                        parameterName="opening_balance_date"
                        newCallback={onDateChange}
                        options={{
                            startDate: formState.opening_balance_date,
                            singleDatePicker: true,
                            showDropdowns: true,
                            autoApply: true,
                        }}
                    />
                </div>
            </FormBlock>
            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Input
                        isRequired={false}
                        title={i18next.t('NotBindBlock.return.InputOpening_balance_value.title')}
                        name="opening_balance_value"
                        value={opening_balance_value}
                        onChange={sumFormHandler}
                        error={errorsTab.accountStartBalance}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <Select
                        isSmartPosition
                        selected={selectedCurrency || null}
                        onChange={onCurrencyChange}
                        placeholder={i18next.t('NotBindBlock.return.Select.placeholder')}
                        title={i18next.t('NotBindBlock.return.Select.title')}
                        isRequired
                        options={currentList}
                        error={errorsTab.currency}
                    />
                </div>
            </FormBlock>

            <Checkbox
                title={i18next.t('NotBindBlock.return.Checkbox.title')}
                isActive={isActiveCheckbox}
                onClick={onCheckboxChange}
                isDisabled={false}
            />
        </div>
    );
};
